import { flow, getEnv, types, applySnapshot, getSnapshot} from "mobx-state-tree";
import {TagSelectState} from "../../elements/tags/TagSelectState";
import {GroupSelectState} from "../../elements/groups/GroupSelectState";
import Group from "../../../models/Group";
import lodash, { update } from "lodash";
import Notification from "../../../utils/Notification";
import {DimensionSelectViewState} from "../../elements/dimensions/dimensionSelectViewState";
import {
  Label,
  Row,
  FormGroup
} from "reactstrap";
import DimensionSelect from "../../elements/dimensions/dimensionSelect";
import {FormattedMessage, useIntl} from "react-intl";
import {PublishDomainSelectState} from "../../elements/publishDomain/PublishDomainSelectState";
import {CodeFilterSelectState} from "../../elements/filters/CodeFilterSelectState";
import {CodeModelList} from "../../../models/codes/Code";
import {QrConfigSelectState} from "../../elements/qrconfig/QrConfigSelectState";
import { BatchList } from "../../../models/batch/BatchList";
import {QrDownloadState} from "../../qr/qrpreview/qrDownload/QrDownloadState";
import {batchTypesConstatns, batchEditTypes, batchEditTag, batchEditAdvancedConfigs, protocolConstants} from "src/utils/constants";
import { TagModel as Tag, TagModel } from "../../../models/tags/TagModel";
import { updateInfoAfterSelectGroup } from "../../../utils/group";
import { Batch } from "../../../models/batch/Batch";
import Papa from 'papaparse';
import { saveAs } from 'file-saver';
import { UtmModalState } from "../../utms/modal/UtmModalState";
import { Utm } from "../../../models/utms/UtmModel";
import {ModalState} from "../../elements/modal/GenericModal";
import { addUtmToCode } from "../../utms/utils/UtmUtils";
import { ParameterSetModalState } from "../../configs/parametersets/modal/ParameterSetModalState";
import Parameters from "../../../models/Parameters";
import { addParameterSetToCode } from "../../configs/parametersets/utils/ParameterSetsUtil";
import { RuleSetModalState } from "../../configs/rulesets/modal/RuleSetModalState";
import { addRulesToCode } from "../../configs/rulesets/utils/RuleSetsUtil";
import { DesignerModalState } from "../../qr/modal/DesignerModalState";
import { StatusState } from "../../configs/status/StatusState";
import { DefaultSettingModel } from "../../../models/defaultSetting/DefaultSettingModel";
import { fetchAndHydrateDefaultSetting as fetchAndHydrateDefaultSettingUtil } from "../../../utils/defaultSettingUtils";
import {ExtendedDataSettingModalState} from "../../extendedData/modal/ExtendedDataSettingModalState";
import {addExtendedDataToCode} from "../../extendedData/utils/ExtendedDataUtil";
import {ExtendedDataModel} from "../../../models/extendedData/ExtendedData";

const defaultSelectedAdvancedConfigs = [batchEditAdvancedConfigs.UTM, batchEditAdvancedConfigs.PARAMETERS, batchEditAdvancedConfigs.RULES, batchEditAdvancedConfigs.STATUS, batchEditAdvancedConfigs.DESIGNER_QR, batchEditAdvancedConfigs.EXTENDED_DATA]

const BatchFormState = types.model('BatchFromState',{
  id: types.optional(types.identifier, 'bfs'),
  title: types.optional(types.string, 'New Batch'),
  tagSelectStore: types.maybe(types.late(() => types.reference(TagSelectState))),
  selectedTags: types.optional(types.array(types.string), []),
  formHasErrors: types.optional(types.boolean, false),
  errorMessage: types.optional(types.string, "Null"),
  batchName: types.optional(types.string, ""),
  batchType: types.optional(types.string, batchTypesConstatns.CREATE),
  groupSelectStore: types.maybe(types.late(() => types.reference(GroupSelectState))),
  selectedGroup: types.maybe(types.reference(Group)),
  dimensionSelectViewState: types.maybe(types.late(() => types.reference(DimensionSelectViewState))),
  selectedDimensions: types.optional(types.string, '{}'),
  showTagDownloadBox: types.optional(types.boolean, false),
  buttonText: types.optional(types.string, "Process"),
  codeStatus: types.optional(types.string, "PUBLISHED"),
  publishDomainSelectStore: types.maybe(types.late(() => types.reference(PublishDomainSelectState))),
  selectedDefaultUrl: types.optional(types.string, ''),
  activeTab: types.optional(types.string, 'files'),
  selectedCodeType: types.optional(types.string, 'url'),
  imageFormat: types.optional(types.string, 'png'),
  codeFilterSelectState: types.maybeNull(types.reference(CodeFilterSelectState)),
  qrConfigSelectStore: types.maybeNull(types.late(() => types.reference(QrConfigSelectState))),
  codeModels: types.maybe(types.late(() => CodeModelList)),
  selectedQrConfig: types.optional(types.string, ""),
  downloadCounts: types.optional(types.number, 0),
  isDefaultBatchOperation: types.optional(types.boolean, true),
  batchSelectStore: types.maybe(types.late(() => types.reference(BatchList))),
  selectedBatch: types.maybe(types.reference(Batch)),
  editType: types.optional(types.string, batchEditTypes.TAG),
  editValue: types.optional(types.string, ""),
  qrDownloadStore: types.maybeNull(QrDownloadState),
  v1ImageConfig: types.optional(types.frozen(), {}),
  tagOperation: types.optional(types.string, batchEditTag.ADD_TAG),
  availableNewSelectedTags: types.optional(types.array(types.reference(TagModel)), []),
  updatedSelectedTags: types.optional(types.array(types.reference(TagModel)), []),
  isFilterTagTypeOR: types.optional(types.boolean, true),
  isBatchEditable: types.optional(types.boolean, true),
  selectedProtocol: types.optional(types.enumeration([protocolConstants.HTTP, protocolConstants.HTTPS]), protocolConstants.HTTP),
  protocolDefaultsEnabled: types.optional(types.boolean, false),
  protocolDefaults: types.optional(types.frozen(), {}),
  createdDate: types.optional(types.string, ""),
  batchUuid: types.optional(types.string, ""),
  utmModalState: types.maybe(types.late(() => UtmModalState)),
  utm: types.maybe(types.late(() => Utm)),
  statusViewState: types.maybe(types.late(() => StatusState)),
  batchStatus: types.maybe(types.late(() => StatusState)),
  modalStore: types.maybe(ModalState),
  parameterSetModalState:types.maybe(types.late(() => ParameterSetModalState)),
  parameters: types.maybe(Parameters),
  ruleSetModalState:types.maybe(types.late(() => RuleSetModalState)),
  rules: types.optional(types.string, "[]"),
  designerModalState:types.maybe(types.late(() => DesignerModalState)),
  imageUuid: types.optional(types.string, ""),
  selectedAdvancedConfigs: types.optional(types.array(types.string), defaultSelectedAdvancedConfigs),
  // Resolved once per tenant appConfigs at route entry - batchAdvancedConfigsEnabled (below) derives
  // the effective value from whichever of these applies to the CURRENT batchType.
  createAdvancedConfigsEnabled: types.optional(types.boolean, false),
  editAdvancedConfigsEnabled: types.optional(types.boolean, false),
  defaultSetting :types.maybe(types.late(() => DefaultSettingModel)),
  defaultSettingFeatureFlag: types.optional(types.boolean, false),
  extendedData: types.maybe(types.late(() => ExtendedDataModel)),
  extendedDataSettingModalState: types.maybe(types.late(() => ExtendedDataSettingModalState)),
  extendedDataList: types.optional(types.array(types.frozen()), []),
}).volatile((self)=>({
  notifySelect: types.fn,
  handleSubmit: types.fn, //this type doesnt really exist
  handleCancel: types.fn,
  // batchManager: types.other,
  uploadFiles: types.fn,
  downloadType: types.str,
  searchParams: {},
  modalComponent: types.object,
  modalComponentStore: types.object,
  modalSize: types.str,
  modalClassName: types.str,
}))
  .views((self) => ({
    // batchType is mutable in-session (the Batch Type dropdown), so this must stay reactive
    // to it rather than being resolved once at route entry - otherwise switching Create -> Edit
    // (or vice versa) would keep using whichever flag was true when the form first loaded.
    get batchAdvancedConfigsEnabled() {
      return self.batchType === batchTypesConstatns.EDIT ? self.editAdvancedConfigsEnabled : self.createAdvancedConfigsEnabled
    }
  }))
  .actions((self)=>{
    let initialState = {};
    const countCodesBatchType = [batchTypesConstatns.DOWNLOAD, batchTypesConstatns.EDIT]
    return {
      setUploadFiles(fn) {
        self.uploadFiles = fn;
        // self.files = files;
      },
      setHandleSubmit(fn) {
        self.handleSubmit = fn
      },
      handleHasErrors(boolean) {
        self.formHasErrors = boolean
      },
      handleErrorMessage(message) {
        self.errorMessage = message
      },
      setHandleCancel(fn) {
        self.handleCancel = fn
      },
      reset() {
        self.resetBatchOptions()
        applySnapshot(self, {
          ...initialState,
          codeModels: self.codeModels,
          codeFilterSelectState: self.codeFilterSelectState,
          qrConfigSelectStore: self.qrConfigSelectStore,
          qrDownloadStore: self.qrDownloadStore,
          batchSelectStore: self.batchSelectStore,
          publishDomainSelectStore: self.publishDomainSelectStore,
          groupSelectStore: self.groupSelectStore,
          tagSelectStore: self.tagSelectStore,
          dimensionSelectViewState: self.dimensionSelectViewState,
          utmModalState: self.utmModalState,
          utm: self.utm,
          modalStore: self.modalStore,
          parameterSetModalState: self.parameterSetModalState,
          parameters: self.parameters,
          designerModalState: self.designerModalState,
          statusViewState: self.statusViewState,
          ruleSetModalState: self.ruleSetModalState,
          createAdvancedConfigsEnabled: self.createAdvancedConfigsEnabled,
          editAdvancedConfigsEnabled: self.editAdvancedConfigsEnabled,
          extendedDataSettingModalState: self.extendedDataSettingModalState
        });
      },
      setOnSelectChanges() {
        self.groupSelectStore?.setConsumer(self.selectGroup)
        self.tagSelectStore?.setConsumer(self.selectTag)
        self.publishDomainSelectStore?.setConsumer(self.selectPublishDomain)
        self.dimensionSelectViewState?.setConsumer(self.selectDimension)
        self.codeFilterSelectState?.setConsumer(self.selectFilter)
        self.qrConfigSelectStore?.setConsumer(self.selectQrConfig)
        self.designerModalState?.setConsumer(self.handleImageUuidChange)
        self.extendedDataSettingModalState?.setConsumer(self.selectExtendedData)
      },
      addSearchParams(param) {
        self.searchParams = {...self.searchParams, ...param}
      },
      removeSearchParams(names) {
        if (names) {
          names.map((name) => delete self.searchParams[name])
        }
      },
      selectTag(arr) {
        self.selectedTags = arr.flatMap((tag) => tag.uuid)
        if (countCodesBatchType.includes(self.batchType)) {
          self.countDownloadQrCodes()
        }
      },
      selectGroup: flow(function* (obj) {
        updateInfoAfterSelectGroup(self, obj)
        self.addSearchParams({groupUuid: obj?.uuid})
        console.log('select group batchType: ', self.batchType)
        if (countCodesBatchType.includes(self.batchType)) {
          self.qrConfigSelectStore.setSelectedGroup(obj.uuid)
          self.countDownloadQrCodes()
        }

        // Fetch default settings when group is selected
        if (obj) {
          yield self.fetchAndHydrateDefaultSetting()
        }
      }),
      selectPublishDomain(obj) {
        self.selectedDefaultUrl = obj.name
        if (countCodesBatchType.includes(self.batchType)) {
          self.countDownloadQrCodes()
        }
      },
      selectDimension: flow(function* (obj, parentUuid) {
        let existingDimension = JSON.parse(self?.selectedDimensions)
        existingDimension[parentUuid] = obj?.uuid
        existingDimension = lodash.pickBy(existingDimension, value => !(lodash.isEmpty(value))); // to delete empty  object
        self.selectedDimensions = JSON.stringify(existingDimension)
        console.log('select dimension batchType: ', self.batchType)
        if (countCodesBatchType.includes(self.batchType)) {
          self.countDownloadQrCodes()
        } else {
          yield self.fetchAndHydrateDefaultSetting()
        }
      }),
      selectExtendedData(d) {
        const selectedExtendedData = self.extendedDataSettingModalState?.getSelectedExtendedDataMap() || {};
        self.extendedDataList = Object.values(selectedExtendedData).map(item => getSnapshot(item));
      },
      selectExtendedDataSelection(d) {
        const selectedExtendedData = self.extendedDataSettingModalState?.getSelectedExtendedDataMap() || {};
        self.extendedDataList = Object.values(selectedExtendedData).map(item => getSnapshot(item));
      },
      selectQrConfig(obj) {
        self.selectedQrConfig = obj.uuid
        const qrConfig = JSON.parse(self.qrConfigSelectStore.selectedConfig.qrConfig)
        self.qrDownloadStore.handleOptions(qrConfig, self.v1ImageConfig)
      },
      getDimensions() {
        if (lodash.isEmpty(JSON.parse(self.selectedDimensions))) return undefined
        return JSON.parse(self.selectedDimensions)
      },
      setDownloadType(type) {
        self.downloadType = type
      },
      handleBulkDownloadOrEdit: flow(function* f(data, batchType) {
        const manager = getEnv(self).bulkManager;
        const queryParams = {
          ...self.searchParams
        }
        const config = {
          params: queryParams
        }
        const res = yield manager.handleBulkDownloadOrEdit(data, self, config, batchType);
        self.formHasErrors && new Notification()
          .setType("error")
          .setMessage(`${self.title} failed updating`)
          .send();
        !self.formHasErrors && new Notification()
          .setType("success")
          .setMessage(`${self.title} updated`)
          .send();
        return res;
      }),
      handleCsvUpload: flow(function* f(data) {
        const manager = getEnv(self).bulkManager;
        const res = yield manager.handleCsvUpload(data, self);
        self.formHasErrors && new Notification()
          .setType("error")
          .setMessage(`${self.title} failed updating`)
          .send();
        !self.formHasErrors && new Notification()
          .setType("success")
          .setMessage(`${self.title} updated. ${res.message}`)
          .send();
        return res;
      }),
      checkCsvFile(file, codeType) {
        if(file.length === 0) {
          console.log("No file selected")
          return false
        }
        // we only accept one file and it must be a csv
        if(!file[0].name.endsWith(".csv")) return false

        let requiredColumns = []
        let mustHaveValue = ["Code Name", "Landing URL"];
        if(codeType === 'url') {
          requiredColumns = ['Code Name', 'Landing URL']
        } else if(codeType === 'gs1') {
          requiredColumns = ['Code Name', 'Landing URL', 'GTIN']
          mustHaveValue = ["Code Name", "Landing URL", "GTIN"]
        }
        return new Promise((resolve, reject) => {
          Papa.parse(file[0], {
            complete: (results) => {
              const data = results.data;
              const headers = data[0];
              console.log('csv headers: ', headers)
              // Check required columns
              const hasAll = requiredColumns.every(c => headers.includes(c));
              if (!hasAll) {
                console.log("Missing required columns")
                new Notification()
                        .setType("error")
                        .setMessage(`Missing required columns`)
                        .send();
                return resolve(false);
              };

              const filteredData = data.filter(row => {
                // Check if every cell is empty or whitespace
                return !row.every(cell => !cell || !cell.trim());
              });

              // Check must-have-value columns
              const missingValueColumn = mustHaveValue.find(col => {
                return filteredData.slice(1).some((row, rowIndex) => {
                  const value = row[headers.indexOf(col)];
                  // console.log(`Row #${rowIndex + 2} [${col}] =`, JSON.stringify(value));
                  return !value?.trim();
                });
              });

              if (missingValueColumn) {
                console.log(`Column "${missingValueColumn}" has empty values in some rows`);
                new Notification()
                        .setType("error")
                        .setMessage(`Column "${missingValueColumn}" has empty values in some rows`)
                        .send();
                return resolve(false);
              }

              resolve(true);
            },
            error: (err) => {
              console.log(err.message)
              reject(false)
            },
          });
        });

      },

      handleBatchNameChange(e) {
        self.batchName = e.target.value
      },
      afterCreate() {
        // self.batchManager = new BulkManager()
      },
      afterAttach() {
        // Set up all consumer callbacks after the node is attached to the tree
        // This ensures all references are resolved
        self.setOnSelectChanges()
      },
      buildDimensions(dimensionSelectStore) {
        return (
          <FormGroup>
            <Label className="text-sm-right"><FormattedMessage
              id={`createQr.dimensions.${dimensionSelectStore?.dimension?.label}.defaultMessage`}
              defaultMessage={dimensionSelectStore?.dimension?.label}/>:</Label>

            <DimensionSelect dimensionSelectStore={dimensionSelectStore} disabled={!self.isBatchEditable}/>
          </FormGroup>

        )
      },
      setBatchType: flow(function*(type, qrPreviewStore) {
        self.batchType = type
        if (countCodesBatchType.includes(type)) {
          self.resetBatchOptions(qrPreviewStore)
          self.setShowTagDownloadBox(true)
          self.setActiveTab('tags')
          self.countDownloadQrCodes()
          if(type === batchTypesConstatns.EDIT) {
            self.statusViewState.setBatchModal(true)
            self.selectedAdvancedConfigs = []
          } else if(type === batchTypesConstatns.DOWNLOAD) {
            self.selectedAdvancedConfigs = []
          }
          self.defaultSetting.clearAllSelections()
          yield self.fetchAndHydrateDefaultSetting()
        } else {
          self.setShowTagDownloadBox(false)
          self.setActiveTab('files')
          self.selectedAdvancedConfigs = defaultSelectedAdvancedConfigs
          self.resetBatchOptions(qrPreviewStore)
          yield self.fetchAndHydrateDefaultSetting()
        }
      }),
      // reset all modal states
      resetBatchOptions(qrPreviewStore) {
        self.resetUTM()
        self.resetParameters()
        self.resetRules()
        self.resetStatus()
        self.resetDesigner(qrPreviewStore, self.designerModalState)
        self.resetExtendedData()
      },
      resetUTM() {
        self.utm.reset()
        self.utmModalState.reset()
        self.utmModalState.initializeSelectVisibility()
      },
      resetParameters() {
        self.parameters.clearParams()
        self.parameterSetModalState.clearParameters()
      },
      resetRules() {
        self.rules = "[]"
        self.ruleSetModalState.reset()
      },
      resetStatus() {
        self.codeStatus = "PUBLISHED"
        self.statusViewState.reset()
      },
      resetDesigner(qrPreviewStore) {
        self.imageUuid = ""
        self.designerModalState.designerViewStore.reset(self.designerModalState)
        self.designerModalState.setRemovedDesignerModal(false)
        self.designerModalState.setCustomOpen()
        self.designerModalState.designerViewStore.qrConfigSelectStore.resetSelectedConfig()
        if(qrPreviewStore) {
        qrPreviewStore.setPreviewImageNull()
        }
      },
      resetExtendedData(){
        self?.extendedDataSettingModalState?.clearState()
      },
      setShowTagDownloadBox(boolean) {
        self.showTagDownloadBox = boolean
      },
      setButtonText(text) {
        self.buttonText = text
      },
      setCodeStatus(statusStore) {
        if(self.batchType === batchTypesConstatns.EDIT) {
          self.statusViewState.setChangedStatus(true)
        }
        self.codeStatus = statusStore.status
        self.batchStatus.setScheduleStatusChangeValue(statusStore.scheduleStatusChange)
        self.batchStatus.setStatusScheduleData(statusStore.getStatusScheduleData())
      },
      setActiveTab(tab) {
        self.activeTab = tab
        self.setDownloadType(tab)
      },
      setCodeType(experience) {
        self.selectedCodeType = experience
        if (self.protocolDefaultsEnabled && self.protocolDefaults && Object.keys(self.protocolDefaults).length > 0) {
          const codeTypeName = experience?.toLowerCase();
          const protocol = self.protocolDefaults[codeTypeName] || self.protocolDefaults.default || protocolConstants.HTTP;
          self.setSelectedProtocol(protocol);
        }
        self.fetchAndHydrateDefaultSetting()
      },
      handleImgFormat(format) {
        self.imageFormat = format.value
        self.qrDownloadStore.handleDownloadImageFormat(format)
      },
      selectFilter(obj, covered) {
        self.codeModels.removeSearchParams(covered, /^dimension/);
        const transpiledDimensions = {};
        if (obj) {
          if (!lodash.isEmpty(obj.dimensions)) {
            obj.dimensions.forEach(dimension => {
              const [uuid, value] = dimension.split('_');
              if (transpiledDimensions.hasOwnProperty(`dimension[${uuid}]`)) {
                transpiledDimensions[`dimension[${uuid}]`] += ',' + value;
              } else {
                transpiledDimensions[`dimension[${uuid}]`] = value;
              }
            });
            delete obj.dimensions
          }
        }
        const params = lodash.mapValues(obj,(value, key) => {
          return {}[key] = value.join(',');
        });
        self.codeModels.addSearchParams({...params, ...transpiledDimensions});
        self.countDownloadQrCodes()
      },
      fetchFilters() {
        self.codeModels.fetchAllFilters();
      },
      countDownloadQrCodes: flow(function* countDownloadQrCodes(sortParams = {}) {
        const info = self.generateDownloadFilterInfo()
        const queryParams = {
          ...sortParams,
          ...info
        }
        console.log('info: ', info)
        const manager = getEnv(self).bulkManager;
        const count = yield manager.countBatchQrcodes(queryParams);
        self.downloadCounts = count.data.totalQrcodes
      }),
      generateDownloadFilterInfo() {
        let dimensions = {};
        console.log('self.groupSelectStore', self.groupSelectStore)
        self.dimensionSelectViewState.dimensionSelectStates.forEach(item => {
          if (item.selectedDimension) {
            dimensions[item.selectStateUuid] = item.selectedDimension.uuid;
          }
        });
        const details = {
          details: {
            tags: self.tagSelectStore.selectedTags.flatMap((tag)=>{ return tag.uuid}),
            owner: {
              dimensions: dimensions,
              groupUuid: self.groupSelectStore.selectedGroup.uuid
            },
            filter: self.codeModels.searchParams,
            isFilterTagTypeOR: self.isFilterTagTypeOR
          }

        }
        return details
      },
      toggleIsDefaultBatchDownload() {
        self.isDefaultBatchDownload = !self.isDefaultBatchDownload
      },
      toggleIsDefaultBatchOperation() {
        self.isDefaultBatchOperation = !self.isDefaultBatchOperation
      },
      setColumns(col) {
        self.columns = col
      },
      setSelectedProtocol(protocol) {
        self.selectedProtocol = protocol
      },
      setEditType(type) {
        self.editType = type
      },
      setEditValue(value) {
        self.editValue = value
      },
      setTagOperation(value) {
        self.tagOperation = value
      },
      setUpdatedSelectedTags(tags) {
        self.updatedSelectedTags = tags
      },
      selectFilterTagMethod() {
        self.isFilterTagTypeOR = !self.isFilterTagTypeOR
        self.countDownloadQrCodes()
      },
      downloadBatchCreateCSV: flow(function* downloadBatchCreateCSV() {
        const manager = getEnv(self).batchManager;
        const res = yield manager.downloadBatchCreateCSV(self.batchUuid);
        saveAs(res.downloadUrl)
      }),
      handleConfigModalPopUp(component, title, componentStore, size = "", className = "", qrPreviewStore) {
        console.log("handleConfigModalPopUp:", self)
        self.modalComponentStore = self[componentStore];
        self.modalComponent = component;
        self.modalSize = size;
        self.modalClassName = className;
        self.modalStore.toggle()
        self.modalStore.handleTitle(title)

        if(title === batchEditAdvancedConfigs.UTM) {
          self.utmModalState.utm.hydrateUtm(self.utm)
          self.utmModalState.initializeSelectVisibility()
        }

        if(title === batchEditAdvancedConfigs.PARAMETERS) {
          let savedCodeParamTypes = self.parameters.codeParamType
          let selectedCodeParameters = self.parameterSetModalState.codeParamsTypeSelectState.store.getCodeParameters().filter((param) => savedCodeParamTypes.includes(param.uuid))
          self.parameterSetModalState.codeParamsTypeSelectState.selectedCodeParameters = selectedCodeParameters

          let savedScanParamTypes = self.parameters.scanParamType
          let selectedScanParameters = self.parameterSetModalState.scanParamsTypeSelectState.store.getScanParameters().filter((param) => savedScanParamTypes.includes(param.uuid))
          self.parameterSetModalState.scanParamsTypeSelectState.selectedScanParameters = selectedScanParameters

          let savedCountParamTypes = self.parameters.countParamType
          let selectedCountParameters = self.parameterSetModalState.countParamsTypeSelectState.store.getCodeParameters().filter((param) => savedCountParamTypes.includes(param.uuid))
          self.parameterSetModalState.countParamsTypeSelectState.selectedCountParameters = selectedCountParameters

          let savedPremiumParamTypes = self.parameters.premiumParamType
          let selectedPremiumParameters = self.parameterSetModalState.premiumParamsTypeSelectState.store.getCodeParameters().filter((param) => savedPremiumParamTypes.includes(param.uuid))
          self.parameterSetModalState.premiumParamsTypeSelectState.selectedPremiumParameters = selectedPremiumParameters

          let savedCustomParamTypes = self.parameters.customParamType
          let selectedCustomParameters = self.parameterSetModalState.customParamsTypeSelectState.store.getCodeParameters().filter((param) => savedCustomParamTypes.includes(param.uuid))
          self.parameterSetModalState.customParamsTypeSelectState.selectedCustomParameters = selectedCustomParameters

          let savedGs1ParamType = self.parameters.gs1ParamType
          let selectedGs1Parameters = self.parameterSetModalState.gs1ParamsTypeSelectState.store.getGS1Parameters().filter((param) => savedGs1ParamType.includes(param.uuid))
          self.parameterSetModalState.gs1ParamsTypeSelectState.selectedGS1Parameters = selectedGs1Parameters

          let savedEdParamType = self.parameters.edParamType
          let selectedEdParameters = self.parameterSetModalState.parameterExtendedDataSelectStore.store.getExtendedData().filter((param) => savedEdParamType.includes(param.uuid))
          self.parameterSetModalState.parameterExtendedDataSelectStore.setSelectedExtendedData(selectedEdParameters)

          self.parameterSetModalState.generateBatchLocks(self.parameters)
        }

        if(title === batchEditAdvancedConfigs.RULE_SET) {
          self.ruleSetModalState.createRuleSetState.hydrateTree(JSON.parse(self.rules))
        }

        if(title === batchEditAdvancedConfigs.STATUS) {
          self.statusViewState.setStatus(self.codeStatus)
          self.statusViewState.scheduleStatusChange = self.batchStatus.scheduleStatusChange
          self.statusViewState.setStatusScheduleData(self.batchStatus.getStatusScheduleData())
        }

        if(title === batchEditAdvancedConfigs.DESIGNER_QR) {
          if(self.imageUuid == "") {
            self.resetDesigner(qrPreviewStore)
          } else {
            self.qrConfigSelectStore.setSelectedConfig(self.imageUuid)
            self.designerModalState.designerViewStore.hydrateEditComponent(self.qrConfigSelectStore.selectedConfig)
            qrPreviewStore.setQRImageFormData(self.qrConfigSelectStore.selectedConfig.qrConfig)
          }
        }

        if(title === batchEditAdvancedConfigs.EXTENDED_DATA){
          self.extendedDataSettingModalState?.extendedDataSetSelectStore?.select()
        }
      },
      addUtmToCode() {
        addUtmToCode(self)
      },
      hasExtendedData() {
        return self.getExtendedDataList()?.length && self.extendedDataSettingModalState?.showDropdown;
      },
      getExtendedDataList() {
        return self.extendedDataList?.filter(n => n);
      },
      experienceExtendedDataView() {
        return self.extendedDataSettingModalState?.formData;
      },
      getExtendedDataRequest() {
        return self.hasExtendedData() ? {
          "items": self?.getExtendedDataList()?.map((item) => item.uuid),
          "data": self?.experienceExtendedDataView()
        } : {};
      },
      // configButtonColor(bool) {
      //   if(self.utmModalState.noUtmOpen) {
      //     console.log("configButtonColor")
      //     return "secondary"
      //   }
      //   return bool ? "secondary" : "primary"
      // },
      // configClassName(bool) {
      //   if(self.utmModalState.noUtmOpen) {
      //     console.log("configClassName")
      //     return "btn-outline-secondary mr-1 mb-1"
      //   }
      //   return bool ? "btn-outline-secondary mr-1 mb-1" : "btn-outline-primary mr-1 mb-1"
      // },
      // checkRemoveUTMOption(){
      //   console.log("check UTM:",self.utmModalState)
      //   // if(self.utmModalState.noUtmOpen) {
      //   //   console.log("notUtmOpen")
      //   //   return true
      //   // }
      //   return self.utmModalState.utm.removeUTM? true : false;
      // },
      // checkUtmBeEdit(){
      //   console.log("checkUtmBeEdit")
      //   if(self.utmModalState.noUtmOpen) {
      //     console.log("noUtmOpen")
      //     return false
      //   } else if (self.utmModalState.utm.doesUtmHaveValue()) {
      //     console.log("doesUtmHaveValue")
      //     return false
      //   }
      //   return true
      // },
      addParameterSetToCode() {
        addParameterSetToCode(self)
      },
      addExtendedDataToCode() {
        addExtendedDataToCode(self)
      },
      addRulesToCode(){
        addRulesToCode(self)
      },
      handleImageUuidChange(uuid) {
        self.imageUuid = uuid
      },
      setSelectedAdvancedConfigs(configs, qrPreviewStore) {
        self.selectedAdvancedConfigs = configs.map(item => item.value)
        if (!self.selectedAdvancedConfigs.includes(batchEditAdvancedConfigs.UTM)) {
          self.resetUTM()
        }
        if (!self.selectedAdvancedConfigs.includes(batchEditAdvancedConfigs.PARAMETERS)) {
          self.resetParameters()
        }
        if (!self.selectedAdvancedConfigs.includes(batchEditAdvancedConfigs.RULES)) {
          self.resetRules()
        }
        if (!self.selectedAdvancedConfigs.includes(batchEditAdvancedConfigs.STATUS)) {
          self.resetStatus()
        }
        if (!self.selectedAdvancedConfigs.includes(batchEditAdvancedConfigs.DESIGNER_QR)) {
          self.resetDesigner(qrPreviewStore)
        }
        if (!self.selectedAdvancedConfigs.includes(batchEditAdvancedConfigs.EXTENDED_DATA)) {
          self.resetExtendedData()
        }
      },
      fetchAndHydrateDefaultSetting: flow(function* (codeTypeUuid = null) {
        if (self.defaultSettingFeatureFlag && self.batchAdvancedConfigsEnabled) {

          try {
            // Guard: Skip if defaultSetting is not initialized (e.g., in batchItems/Details view)
            if (!self.defaultSetting) {
              console.log('BatchFormState: defaultSetting not initialized, skipping fetch');
              return;
            }


            // Get groupUuid from MST reference (now works because BatchFormState is in rootStore tree)
            const groupUuid = self.groupSelectStore?.selectedGroup?.uuid;
            console.log('BatchFormState: Using group from store:', {
              groupUuid,
              groupName: self.groupSelectStore?.selectedGroup?.name
            });

            // Build dimension mapping from MST reference first
            let dimensions = {};
            if (self.dimensionSelectViewState?.dimensionsEnabled && self.dimensionSelectViewState?.dimensionSelectStates) {
              dimensions = self.dimensionSelectViewState.dimensionSelectStates.reduce(
                (acc, dimensionSelectStore) => {
                  const dimensionUuid = dimensionSelectStore.selectedDimension?.uuid;
                  console.log(`BatchFormState: Dimension ${dimensionSelectStore.selectStateUuid}:`, {
                    dimensionUuid,
                    dimensionName: dimensionSelectStore.selectedDimension?.name
                  });
                  acc[dimensionSelectStore.selectStateUuid] = dimensionUuid || "";
                  return acc;
                },
                {}
              );
            }

            // Fallback: if MST dimensions are empty, try JSON stored dimensions from selectDimension()
            if (lodash.isEmpty(dimensions) && self.selectedDimensions) {
              try {
                const jsonDimensions = JSON.parse(self.selectedDimensions);
                if (!lodash.isEmpty(jsonDimensions)) {
                  dimensions = jsonDimensions;
                }
              } catch (e) {
                console.warn('BatchFormState: Failed to parse selectedDimensions JSON:', e);
              }
            }

            const query = {
              groupUuid: groupUuid,
              type: self.selectedCodeType,
              dimensions: dimensions
            };

            console.log('BatchFormState: fetchAndHydrateDefaultSetting final query:', query);

            // Only proceed if we have at least a groupUuid
            if (!groupUuid) {
              console.warn('BatchFormState: No group available, skipping default settings fetch');
              return;
            }

            yield fetchAndHydrateDefaultSettingUtil({
              componentState: self,
              query,
              hasExtendedDataModal: false, //revert once extended Data edit fix
              selectExtendedDataSelection: null, //revert once extended Data edit fix
              designerConfig: {
                isDesignerTemplateExperience: false,
                isClone: false,
                hydrateDimensions: false
              }
            });
          } catch (e) {
            console.error(`BatchFormState Error: Failed to hydrateDefaultSetting`, e);
          }
        }
      }),
    }
  }).views((self) => ({
    parametersHaveValue() {
      return self.parameters.codeParamType.length > 0
        || self.parameters.scanParamType.length > 0
        || self.parameters.countParamType.length > 0
        || self.parameters.premiumParamType.length > 0
        || self.parameters.customParamType.length > 0
        || self.parameters.gs1ParamType.length > 0
        || self.parameters.edParamType.length > 0
        || self.parameters.batchCodeParamTypeLock
        || self.parameters.batchScanParamTypeLock
        || self.parameters.batchCountParamTypeLock
        || self.parameters.batchPremiumParamTypeLock
        || self.parameters.batchCustomParamTypeLock
        || self.parameters.batchGS1ParamTypeLock
        || self.parameters.batchEDParamTypeLock
    }
  }))


export default BatchFormState
